import { Button, Divider, SxProps, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import ModalFeedBack from '../../../components/ModalFeedBack';
import { Agendamento } from '../../../interfaces/entities/Agendamento';
import { getAgendamentosTeleorientacao } from '../../../services/AgendamentoService';
import { getUrlNavegacaoTeleorient } from '../../../services/LoginService';
import ModalCancelarAtendimento from '../MeusAgendamentos/ModalCancelarAtendimento';
import TeleorientacaoCard from './TeleorientacaoCard';
import './styles.css';
import { sxButtonTeleorientacao, sxMargin32px, sxTeleorientacaoAvailability, sxTeleorientacaoSubtitle, sxTypographyTeleorientacao, sxTypographyTeleorientacaoBold, sxTypographyTeleorientacaoBoldGreen, sxTypographyTeleorientacaoBoldRed } from './sxProps';
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext';
import CircularProgressLoading from '../../../components/Accessibility/CircularProgressLoading';
import AudioLoadingDescription from '../../../components/Accessibility/AudioLoadingDescription';
import PageTitle from '../../../components/Accessibility/PageTitle';
import { getDisponibilidadeTeleOrientacao } from '../../../services/IngressarAtendimentoService';
import parse from "html-react-parser";

const TeleorientacaoSaude: React.FC = () => {

	const teleorientacaoSubtitle: string = 'Utilize nosso serviço de teleorientação e seja atendido por um profissional de saúde por videochamada, sem sair de casa.';
	const teleorientacaoAvailability: string = 'Disponível de segunda a sexta, das 8h às 20h.';
	const [teleorientacaoSchedule, setTeleorientacaoSchedule] = useState<Agendamento>();
	const [validSchedule, setValidSchedule] = useState<boolean>(false);
	const [showModalFeedback, setShowModalFeedback] = useState<boolean>(false);
	const [loadingUrl, setLoadingUrl] = useState<boolean>(false);
	const [loadingSchedules, setLoadingSchedules] = useState<boolean>(false);
	const [showModalCancelarAtendimento, setShowModalCancelarAtendimento] = useState<boolean>(false);
	const [teleorientationText, setTeleorientationText] = useState<string>('');
	
	const accessibility = useAccessibility();	

	const getScheduleInfo = (): string => {
		return validSchedule ? 'Você possui um atendimento agendado!' : 'O atendimento está expirado, realize um novo agendamento.';
	}

	const getSxScheduleInfo = (): SxProps => {
		return validSchedule ? sxTypographyTeleorientacaoBoldGreen : sxTypographyTeleorientacaoBoldRed;
	}

	const fetchTeleorientacaoSchedules = async () => {
		setLoadingSchedules(true);

		const [schedulesTeleorientation, teleorientationAvailability] = await Promise.all([
			getAgendamentosTeleorientacao(), getDisponibilidadeTeleOrientacao()
		]);
		if (schedulesTeleorientation !== null && teleorientationAvailability !== null) {
			setTeleorientationText(teleorientationAvailability.infoAcesso)
			const schedule = schedulesTeleorientation.at(0);
			setTeleorientacaoSchedule(schedule);
			const validStatus = schedule?.status === 'agendado' || schedule?.status === 'confirmado';
			const acessDenied = teleorientationAvailability.bloqueioAcesso === 'N' ? false : true;
			
			const validSchedule = validStatus && !acessDenied;	
			setValidSchedule(validSchedule);
		} else {
			console.error('Falha ao buscar agendamentos teleorientação.');
		}
		setLoadingSchedules(false);
	};

	useEffect(() => {
		fetchTeleorientacaoSchedules();

		const oneMinuteRefresh = 1 * 60 * 1000;
		const intervalId = setInterval(() => {
			fetchTeleorientacaoSchedules();
		}, oneMinuteRefresh);

		return () => clearInterval(intervalId);
	}, []);

	const handleShowModalFeedback = () => {
		setShowModalFeedback(showModalFeedback => !showModalFeedback);
	}

	const handleClickCancelarAtendimento = () => {
		setShowModalCancelarAtendimento(showModalCancelarAtendimento => !showModalCancelarAtendimento);
	}

	const handleClickScheduleTeleorientacao = async () => {
		setLoadingUrl(true);
		let urlTeleorientResponse = await getUrlNavegacaoTeleorient();
		if (urlTeleorientResponse) {
			window.open(urlTeleorientResponse, '_blank');
		} else {
			handleShowModalFeedback();
		}
		setLoadingUrl(false);
	}

	const existsTeleorientacaoSchedule = (): boolean => {
		return !!teleorientacaoSchedule;
	}

	return (
		<div className='teleorientacao-saude' aria-atomic>
			<AudioLoadingDescription loading={loadingSchedules}/>
			<PageTitle text="Teleorientação em saúde" marginBottom="16px" />
			<div className='teleorientacao-description-container' style={accessibility.textStyleAccessibility}>
				<Typography sx={sxTeleorientacaoSubtitle} style={accessibility.textStyleAccessibility}>{parse(teleorientationText)}</Typography>
			</div>
			{loadingSchedules ? <CircularProgressLoading/> :
				<>
					{!existsTeleorientacaoSchedule() ?
						<Button disabled={loadingUrl} style={accessibility.buttonStyleAccessibility} variant='contained' sx={sxButtonTeleorientacao} onClick={handleClickScheduleTeleorientacao}>
							<Typography style={accessibility.buttonTextStyleAccessibility}>Iniciar Agendamento</Typography>
						</Button>
						:
						<div>
							<Divider sx={sxMargin32px} />
							<Typography style={accessibility.textStyleAccessibility} tabIndex={0} sx={sxTypographyTeleorientacaoBold}>Agendamentos</Typography>
							<div className='margin-bottom-16' />
							<Typography style={accessibility.textStyleAccessibility} tabIndex={0} sx={getSxScheduleInfo()}>{getScheduleInfo()}</Typography>
							<div className='margin-bottom-16' />
							{validSchedule &&
								<>
									<Typography style={accessibility.textStyleAccessibility} tabIndex={0} sx={sxTypographyTeleorientacao}>
										<b>No horário do agendamento</b>, clique no botão INGRESSAR NO ATENDIMENTO para fazer a videochamada.
									</Typography>
									<div className='margin-bottom-16' />
								</>}
							<TeleorientacaoCard
								key={teleorientacaoSchedule!.id}
								validSchedule={validSchedule}
								agendamento={teleorientacaoSchedule!}
								handleClickCancelarAtendimento={handleClickCancelarAtendimento}
							/>
							<div className='margin-bottom-16' />
							{!validSchedule &&
								<Button disabled={loadingUrl} variant='contained' sx={sxButtonTeleorientacao} onClick={handleClickScheduleTeleorientacao}>
									<Typography>Novo Agendamento</Typography>
								</Button>}
							<ModalCancelarAtendimento
								agendamento={teleorientacaoSchedule! || null} handleShowModal={handleClickCancelarAtendimento}
								onComplete={fetchTeleorientacaoSchedules} showModal={showModalCancelarAtendimento}
							/>
						</div>
					}
				</>
			}
			<ModalFeedBack
				icon='error'
				showModal={showModalFeedback}
				textButton='Fechar'
				title='Erro' subTitle='Ocorreu um erro na comunicação com o serviço de agendamentos. Tente novamente em alguns instantes.'
				showButtonModal
				handleButtonModal={handleShowModalFeedback}
				handleShowModal={handleShowModalFeedback}
			/>
		</div>
	)
}

export default TeleorientacaoSaude;